
import {
sendGiftGoods
} from "@/api/sendGiftGoods"
import Alert from 'vux/src/components/alert/index.vue'

export default {
data() {
return {
orderNum:"",//订单号
enderDisabled:true,
};
},

components: {},

computed: {},

created() {},

mounted() {},

methods: {

bindFun:function(){
let that = this;
sendGiftGoods(this.orderNum).then(res => {
if (res.code == 200) {
this.$vux.toast.text("绑定成功", 'middle');
}else{
this.$vux.toast.text(res.msg, 'middle');
}
})
}

}
};



// WEBPACK FOOTER //
// ./src/view/bindMobileNumber/sendGiftGoods.vue